import React, { Component } from "react"

import Grid from "@material-ui/core/Grid"
import { ThemeProvider } from '@material-ui/core/styles';
import {TextareaAutosize, withStyles} from "@material-ui/core"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Cookies } from "react-cookie"
import Snackbar from "@material-ui/core/Snackbar"
import Container from "./someCSS/msSMSHandler";

import { Redirect } from "react-router-dom"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"

import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Paper from "@material-ui/core/Paper";
import TableHead from "@material-ui/core/TableHead";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import TableBody from "@material-ui/core/TableBody";
import {Multiselect} from "multiselect-react-dropdown";




const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      label: {
            direction: "rtl",
            width: "100%",
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },


      select: {
            searchBox: {
                  // To change search box element look
                  border: "none",
                  fontSize: "35px",
                  minheight: "50px",
            },
            inputField: {
                  // To change input field position or margin
                  margin: "5px",
            },
            chips: {
                  // To change css chips(Selected options)
                  background: "red",
            },
            optionContainer: {
                  // To change css for option container
                  border: "2px solid",
            },
            option: {
                  // To change css for dropdown options
                  color: "black",
            },
      },
      btnsearch: {
            [theme.breakpoints.up("md")]: {
                  width: "120px",
                  height: "40px",
                  fontSize: "15px",
            },
            width: "80px",
            height: "30px",
            fontSize: "13px",
            color: "white",
            backgroundColor: "#41589f",
            //  marginRight:'200px',
            //  marginLeft:'200px',
            marginTop: "30px",
            marginBottom: "10px",
            borderRadius: "4px",
            border: "1px solid #41589f",
      },
})
const ms_style ={
      ms_center: { width: "70%", textAlign:"center", margin:'auto', display:'block', height:"200px"},
      ms_text_field : {textAlign:"center", margin:'auto', display:'inline-block', height:"200px"}
    }
const styleselect = {
      multiselectContainer: {
            // To change css for multiselect (Width,height,etc..)
            fontSize: "14px",
            border: "1.25px solid #bababa",
            borderRadius: "4px",
      },
      searchBox: {
            // To change search box element look
            fontSize: "14px",
            minheight: "50px",
            textAlign: "right",
      },
      inputField: {
            // To change input field position or margin
            margin: "5px",
            fontSize: "14px",
      },
      chips: {
            // To change css chips(Selected options)
            //  background: '#00000000',
            border: "2px solid",
            fontSize: "14px",
      },
      optionContainer: {
            // To change css for option container
            textAlign: "right",

      },
      option: {
            // To change css for dropdown options
            fontSize: "14px",
            textAlign: "right",
      },
      groupHeading: {
            // To chanage group heading style
      },

};



class MySweetSMSHandler extends Component {
      cookies = new Cookies()
      paramsCounter = 0
      regex = new RegExp("^[-a-zA-Z0-9/،?=آ-ی .:_-]+$");
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  smsList : [],
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  smsContent : "",
                  smsActivation: "1",
                  smsName : "",
                  selectedId : -1,
                  optionEmployee : [],
                  selectedOptionEmployee : [],
                  messageOnNotFound : ""
            }
      }
      sendSMS = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "success"})
                              self.getAll();
                        }
                        else if (arr.result === "error") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"})
                              return false;
                        }

                  }
            }
            var fd = new FormData()
            fd.append("command", "create")
            fd.append("content", this.state.smsContent)
            fd.append("users", this.state.selectedOptionUser)
            fd.append("agents", this.state.selectedOptionAgent)
            fd.append("employees", this.state.selectedOptionEmployee)

            xhttp.open("POST", `${constants.BASE_URL}MySweetSMS`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      handleChangeSmsContent = e => {
            var key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
            if (!this.regex.test(key)) {
                  e.preventDefault();
                  return false;
            }else
                  this.setState({smsContent: this.state.smsContent + key})

      }

      handleChangeActivation = () => {this.setState({smsActivation: (this.state.smsActivation === "0")? "1": "0"})
      }

      handleChangeName = e => this.setState({ smsName: e.target.value })


      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }
      reset(){
            this.paramsCounter = 0;
            this.setState({
                  smsContent : "",
                  smsActivation: "1",
                  smsName : "",
                  selectedId : -1,
            })
      }

      getAllEmployees = () =>{
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              // var Company1 = [{ value: 0, label: "همه کارمندان " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({
                                          value: arr.data[k].employee_mobile,
                                          label: arr.data[k].employee_name + " " + arr.data[k].employee_family  + " "+ arr.data[k].employee_mobile,
                                    })
                              }
                              self.setState(
                                  { optionEmployee: Company }
                              )
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_employee")

            xhttp.open("POST", `${constants.BASE_URL}/employee`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      update(){
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "success"})
                              self.getAll();

                        }
                        else if (arr.result === "error") {
                              self.setState({snackstr: arr.desc, showSnack: true, snackMode: "error"})
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "update")
            fd.append("my_sweet_sms_id", this.state.selectedId)
            fd.append("my_sweet_sms_activation", this.state.smsActivation)
            fd.append("my_sweet_sms_content", this.state.smsContent)
            fd.append("my_sweet_sms_name", this.state.smsName)
            fd.append("my_sweet_sms_mobiles", self.generateMobileField())

            xhttp.open("POST", `${constants.BASE_URL}MySweetSMS`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)


      }

      generateMobileField(){
            let mobiles = ""
            for (let i = 0; i<this.state.selectedOptionEmployee.length; i++)
                  if (i !== this.state.selectedOptionEmployee.length-1)
                        mobiles += this.state.selectedOptionEmployee[i].value + ","
                  else
                        mobiles += this.state.selectedOptionEmployee[i].value
            return mobiles
      }
      handleClickOnSmsRow = (mySweetSms) => {
            const mobiles = (mySweetSms.my_sweet_sms_mobiles !== null) ? mySweetSms.my_sweet_sms_mobiles.split(",") : []
            let t = []
            for (const mobileKey in mobiles)
                  for (const empKey in this.state.optionEmployee)
                        if(mobiles[mobileKey] === this.state.optionEmployee[empKey].value)
                              t.push(this.state.optionEmployee[empKey])

            this.setState({
                  smsContent :  mySweetSms.my_sweet_sms_content,
                  smsActivation: mySweetSms.my_sweet_sms_activation,
                  smsName : mySweetSms.my_sweet_sms_name,
                  selectedId: mySweetSms.my_sweet_sms_id,
                  selectedOptionEmployee : t
            })
      }


      handleClickOpen = () => {
            this.setState({
                  openDialog: true,
            })
      }

      handleClose = () => {
            this.setState({
                  openDialog: false,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }
      getAll = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              self.setState({smsList : arr.data }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "getAll")

            xhttp.open("POST", `${constants.BASE_URL}MySweetSMS`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    /*
                                          SHOULD BE RELACED
                                     */
                                    self.getAll();
                                    self.getAllEmployees()

                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      onChange = (content) =>{
      }
      render() {
            const self = this

            const { classes } = this.props
            const {
                  redirect,
                  showSnack,
                  snackMode,
                  snackstr,
                  smsList,
                  smsContent,
                  smsActivation,
                  smsName,
                  selectedId,
                  optionEmployee,
                  selectedOptionEmployee

            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (

                  <Container>
                        <Snackbar
                            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                            onClose={this.handleClickcloseTasckBar}
                            open={showSnack}
                            autoHideDuration={10000}
                        >
                              <Alert severity={snackMode}>{snackstr}</Alert>
                        </Snackbar>
                        <Grid container style={{padding: "20px"}} spacing={3}>
                              <Grid item xs={3} >
                                    <TextField
                                        id="standard-basic"
                                        value={smsName}
                                        label="نام پیام"
                                        onChange={this.handleChangeName}
                                        variant="standard"
                                        style={ms_style.ms_text_field}
                                    />
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                    <div style={{ width: "100%", textAlign: "center" }}>
                                          <Multiselect
                                              style={styleselect}
                                              options={this.state.optionEmployee} // Options to display in the dropdown
                                              selectedValues={this.state.selectedOptionEmployee} // Preselected value to persist in dropdown
                                              // onSearch={e => this.setState({messageOnNotFound: e})}
                                              // onChange={(e) => {
                                              //                   console.log("sdfsd",this.state.selectedOptionEmployee)
                                              //                   // this.setState({selectedOptionEmployee: e.value})
                                              //         }
                                              // }
                                              onSelect={e => this.setState({selectedOptionEmployee: e})}
                                              onRemove={e => this.setState({selectedOptionEmployee: e})}
                                              displayValue="label" // Property name to display in the dropdown options
                                              // optionLabel="label"
                                              display="chip"
                                              placeholder="انتخاب کارمند"
                                              closeIcon="circle2"
                                              // emptyRecordMsg={this.state.messageOnNotFound}
                                          />
                                    </div>
                              </Grid>
                              <Grid item xs={3}>
                                    <FormControlLabel
                                        control={
                                              <Switch
                                                  checked={smsActivation === "1"}
                                                  onChange={ this.handleChangeActivation}
                                                  name="gilad"
                                              />
                                        }
                                        label={"وضعیت پیامک"}
                                    />
                              </Grid>

                              <Grid item xs={12}  >
                                    <TextareaAutosize
                                          style={ms_style.ms_center}
                                        placeholder="متن sms"
                                          id={"sms_content"}
                                          value={smsContent}
                                          onClick={e=>{
                                                if(e.detail == 2) {
                                                      this.setState({smsContent: this.state.smsContent + "p" + this.paramsCounter + " "})
                                                      this.paramsCounter++;
                                                }
                                          }}
                                          onKeyPress={e =>{
                                                      this.handleChangeSmsContent(e)
                                          }}
                                          onKeyDown={ (e) => {
                                                if (e.keyCode === 8) {
                                                      const deleted = this.state.smsContent.substring(
                                                          0,
                                                          this.state.smsContent.length -1
                                                      );
                                                      this.setState({smsContent: deleted})
                                                }
                                          }

                                          }
                                    />
                              </Grid>
                              {(selectedId < 0) ?
                                  <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                          onClick={()=>this.saveSMS}>
                                        {"ایجاد sms"}
                                  </Button>

                                  :
                                  <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                          onClick={() => this.update()}>
                                        {"تغییر sms"}
                                  </Button>

                              }
                              <Button style={{padding: "10px"}} variant="outlined" color="primary"
                                      onClick={() => this.reset()}>
                                    {"ریست"}
                              </Button>
                              <Grid item xs={12}>
                                    <Container maxWidth="lg">
                                          <Paper className={classes.root}>
                                                <TableContainer dir="rtl">
                                                      <Table aria-label="sticky table">
                                                            <TableHead>
                                                                  <TableRow>
                                                                        <TableCell
                                                                            key={"sms_id"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}
                                                                        >
                                                                              {" شماره پیام "}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            key={"sms_activation"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" وضعیت پیام "}

                                                                        </TableCell>

                                                                        <TableCell
                                                                            key={"sms_name"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" نام پیام "}

                                                                        </TableCell>
                                                                        <TableCell
                                                                            key={"sms_content"}
                                                                            align={"center"}
                                                                            style={{ minWidth: 20 }}

                                                                        >
                                                                              {" محتوای پیام "}

                                                                        </TableCell>
                                                                  </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                        {smsList.map((sms) =>{
                                                                              return (
                                                                                <TableRow
                                                                                onClick={() => this.handleClickOnSmsRow(sms)}>
                                                                                      <TableCell
                                                                                          key={"sms_id"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {sms.my_sweet_sms_id}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"sms_activation"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {(sms.my_sweet_sms_activation == 1) ? "فعال" : "غیر فعال"}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"sms_name"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {sms.my_sweet_sms_name}
                                                                                      </TableCell>
                                                                                      <TableCell
                                                                                          key={"sms_content"}
                                                                                          align={"center"}
                                                                                      >
                                                                                            {sms.my_sweet_sms_content}
                                                                                      </TableCell>
                                                                                </TableRow>
                                                                              );
                                                                        })}
                                                                  </TableBody>
                                                      </Table>
                                                </TableContainer>
                                          </Paper>
                                    </Container>
                              </Grid>

                     </Grid>
                  </Container>

                  )
            }
      }
}

export default withStyles(styles)(MySweetSMSHandler)
